<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'grey darken-2'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.lock')"
        :icon="error ? 'mdi-alert' : 'mdi-lock'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnLock',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>